import { logEvent as FBLogEvent, getAnalytics } from 'firebase/analytics';

import { app } from '@helpers/firebase/Initialize';

export const analytics = getAnalytics(app);

export async function logEvent(name: string, params: Record<string, any>) {
  return FBLogEvent(analytics, name, params);
}
